module.exports = __webpack_public_path__ + "img/5G-02-05.34df15a4.png";